import Holi1 from "../../src/assets/images/Gallery/Holi/holi-image-one.webp";
import Holi2 from "../../src/assets/images/Gallery/Holi/holi-image-two.webp";
import Holi3 from "../../src/assets/images/Gallery/Holi/holi-image-three.webp";
import Holi4 from "../../src/assets/images/Gallery/Holi/holi-image-four.webp";
import Holi5 from "../../src/assets/images/Gallery/Holi/holi-image-five.webp";
import Holi6 from "../../src/assets/images/Gallery/Holi/holi-image-six.webp";
import GoldInauguration1 from "../../src/assets/images/Gallery/GoldInauguration/gold-inauguration-image-one.webp";
import GoldInauguration2 from "../../src/assets/images/Gallery/GoldInauguration/gold-inauguration-image-two.webp";
import GoldInauguration3 from "../../src/assets/images/Gallery/GoldInauguration/gold-inauguration-image-three.webp";
import GoldInauguration4 from "../../src/assets/images/Gallery/GoldInauguration/gold-inauguration-image-four.webp";
import GoldInauguration5 from "../../src/assets/images/Gallery/GoldInauguration/gold-inauguration-image-five.webp";
import GoldInauguration6 from "../../src/assets/images/Gallery/GoldInauguration/gold-inauguration-image-six.webp";
import GoldInauguration7 from "../../src/assets/images/Gallery/GoldInauguration/gold-inauguration-image-seven.webp";
import GoldInauguration8 from "../../src/assets/images/Gallery/GoldInauguration/gold-inauguration-image-eight.webp";
import GoldInauguration9 from "../../src/assets/images/Gallery/GoldInauguration/gold-inauguration-image-nine.webp";
import GoldInauguration10 from "../../src/assets/images/Gallery/GoldInauguration/gold-inauguration-image-ten.webp";

export const HoliImages = {
    "Holi1": Holi1,
    "Holi2": Holi2,
    "Holi3": Holi3,
    "Holi4": Holi4,
    "Holi5": Holi5,
    "Holi6": Holi6
}

export const GoldInaugurationImages = {
    "GoldInauguration1": GoldInauguration1,
    "GoldInauguration2": GoldInauguration2,
    "GoldInauguration3": GoldInauguration3,
    "GoldInauguration4": GoldInauguration4,
    "GoldInauguration5": GoldInauguration5,
    "GoldInauguration6": GoldInauguration6,
    "GoldInauguration7": GoldInauguration7,
    "GoldInauguration8": GoldInauguration8,
    "GoldInauguration9": GoldInauguration9,
    "GoldInauguration10": GoldInauguration10,
}

